import { Main } from 'wikr-core-analytics';
import { compose } from 'redux';
import type { RouteComponentProps } from 'react-router-dom';
import React from 'react';

import type { WithPreloadNextPageProps } from 'types/onboarding/onboarding';

import withPreloadNextPage from '../withPreloadNextPage';

interface AnalyticProps {
    analytic: {
        track: (event: string, options?: any) => void;
        purchase: (data: any) => void;
        customEvent: (event: string) => void;
        customData: (event: string, data: any) => void;
    };
}

function OnboardingAnalytics<P extends AnalyticProps & RouteComponentProps>(
    WrappedComponent: React.ComponentType<P>,
    trackFlag = true
): React.ComponentType<P & WithPreloadNextPageProps> {
    return class extends React.Component<P & WithPreloadNextPageProps> {
        state = {
            url: this.props.location.pathname.replace(/\//g, ''),
        };

        analytic = Main;

        componentDidMount() {
            if (trackFlag) {
                this.track(this.state.url);
            }
        }

        track(event: string = this.state.url, options: any = undefined) {
            this.analytic.track(event, options);
        }

        purchase(data: any) {
            this.analytic.purchase(data);
        }

        customEvent(eventName: string) {
            this.analytic.track(eventName, { isPrefix: false });
        }

        customData(eventName: string, data: any) {
            this.analytic.customData(eventName, data);
        }

        render() {
            return (
                <WrappedComponent
                    {...this.props}
                    analytic={{
                        track: (event, options) => this.track(event, options),
                        purchase: (data) => this.purchase(data),
                        customEvent: (event) => this.customEvent(event),
                        customData: (event, data) => this.customData(event, data),
                    }}
                />
            );
        }
    };
}

export default compose<React.ComponentType>(withPreloadNextPage, OnboardingAnalytics);
